import React, { FunctionComponent } from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '..';

const BrassIconChevronRight: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faChevronRight} />;

export { BrassIconChevronRight };
